/**
 * Raisons d'annulation d'un achat. Partagées entre l'annulation d'UN achat (fiche) et l'annulation en
 * lot (vues liste) : la même liste doit alimenter les deux, sinon les statistiques d'abandon mélangent
 * deux vocabulaires.
 */
export const ABORT_WITHOUT_REASON_LABEL = 'no-reason-specified';

export const ABORT_OTHER_REASON_VALUE = 'other';

export const STATE_CHANGE_REASONS = [
    { value: 'unreachable-franco', label: 'Franco difficile à atteindre' },
    { value: 'overstock-risk', label: 'Risque de surstock' },
    {
        value: 'too-early',
        label: "Date d'achat prématurée (le delai de livraison fournisseur permet d'attendre encore un peu sans tomber en rupture de stock).",
    },
    { value: 'already-ordered', label: 'Commande déjà passée' },
    { value: 'human-error', label: 'Erreur humaine (achat créé avec le mauvais fournisseur, etc..)' },
    { value: 'supplier-out-of-stock', label: 'Rupture chez le fournisseur' },
    { value: ABORT_OTHER_REASON_VALUE, label: 'Autre' },
];
